import _padStart from "lodash/padStart";
//
import {
  nowTz as nowTimezoned,
  isTodayTz,
  isTomorrowTz,
  localToUtc,
  utcToTz,
} from "../utils/tz";

const timeZones = {
  "Europe/London": 1,
  "Europe/Berlin": 2,
  "Europe/Lisbon": 1,
  "Europe/Amsterdam": 2,
  "Europe/Madrid": 2,
  "Europe/Warsaw": 2,
  "Asia/Bangkok": 7,
  "Asia/Jakarta": 7,
  "Asia/Ho_Chi_Minh": 7,
  "Asia/Phnom_Penh": 7,
  "Asia/Singapore": 8,
  "Asia/Manila": 8,
  "Asia/Hong_Kong": 8,
  "Asia/Kuala_Lumpur": 8,
  "Asia/Macau": 8,
  "Asia/Tokyo": 9,
  "Australia/Sydney": 10,
  "Australia/Melbourne": 10,
  "Asia/Dubai": 4
};

export function formatWeekDay(date, tz) {
  return isToday(date, tz)
    ? "Today"
    : isTomorrow(date, tz)
    ? "Tomorrow"
    : getWeekDay(date, tz);
}

export function formatBookingTime(date, tz, meridiem = true) {
  return `${formatWeekDay(date, tz)} ${formatTime(date, tz, meridiem)}`;
}

export function formatTime(date, tz, meridiem = true) {
  const minutes = date.getUTCMinutes();
  const hours = (date.getUTCHours() + timeZones[tz]) % 24;

  const HH = _padStart(hours > 12 ? hours - 12 : hours, 2, "0");
  const MM = _padStart(minutes, 2, "0");

  const time = `${HH}:${MM}`;

  // Time with/without AM/PM
  return meridiem ? `${time} ${isMorning(date, tz) ? "AM" : "PM"}` : time;
}

export function formatDuration(minutes) {
  const hh = Math.floor(minutes / 60);
  const mm = minutes % 60;

  if (hh > 0) {
    return mm > 0 ? `${hh}h ${mm}m` : `${hh}h`;
  }

  return `${mm}m`;
}

export function isToday(date, tz = null) {
  let dateTz;

  if (tz) {
    dateTz = utcToTz(localToUtc(date), timeZones[tz]);
  } else {
    dateTz = date;
  }

  return isTodayTz(dateTz, timeZones[tz]);
}

export function isTomorrow(date, tz = null) {
  let dateTz;

  if (tz) {
    dateTz = utcToTz(localToUtc(date), timeZones[tz]);
  } else {
    dateTz = date;
  }

  return isTomorrowTz(dateTz, timeZones[tz]);
}

const weekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export function getWeekDay(date, tz = null) {
  let dateTz;

  if (tz) {
    dateTz = utcToTz(localToUtc(date), timeZones[tz]);
  } else {
    dateTz = date;
  }

  return weekDays[dateTz.getDay()];
}

export function isMorning(date, tz = null) {
  let dateTz;

  if (tz) {
    dateTz = utcToTz(localToUtc(date), timeZones[tz]);
  } else {
    dateTz = date;
  }

  return dateTz.getHours() < 12;
}

export function nowTz(tz) {
  return nowTimezoned(timeZones[tz]);
}
